import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class bidderChangesLogs extends BaseRoutes {
	constructor() {
		super('bidder-changes-logs');
	}
}
